import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { detail } from '../../actions/userActions';
import { userUpdateProfileReset } from '../../reducers/userReducers';
import ProfileDetails from './ProfileDetails';
import UpdateProfileModal from './UpdateProfileModal';
import DeleteProfileModal from './DeleteProfileModal';
import { useLocation } from 'react-router-dom';

function ProfileCard() {
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const mainContentRef = useRef(null);
    const location = useLocation();

    const updateModalClose = () => setShowUpdateModal(false);
    const updateModalShow = () => setShowUpdateModal(true);

    const deleteModalShow = () => {
        updateModalClose()
        setShowDeleteModal(true)
    };
    const deleteModalClose = () => {
        updateModalShow()
        setShowDeleteModal(false)
    };
    
    const dispatch = useDispatch();

    const {
        userReducers: { user, userInfo, userUpdateProfileSuccess }
    } = useSelector((state) => state)

    useEffect(() => {
        if (!user || userUpdateProfileSuccess) {
            dispatch(userUpdateProfileReset());
            dispatch(detail());
        }        
    }, [dispatch, userInfo, user, userUpdateProfileSuccess]);

    // Add effect to handle focus management when route changes
    useEffect(() => {
        if (mainContentRef.current) {
            mainContentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location.pathname]);

    return (
        <>  
            { user && <ProfileDetails user={user} updateModalShow={() => setShowUpdateModal(true)} /> }
            { user && <UpdateProfileModal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} user={user} deleteModalShow={deleteModalShow} /> }               
            
            <DeleteProfileModal show={showDeleteModal} onHide={deleteModalClose}/>
            <div ref={mainContentRef} />
        </>
    );
}

export default ProfileCard;
